import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  Typography
} from '@material-ui/core';
const useStyles = makeStyles(theme => ({
  root: {
    height: '100%'
  },
  chartContainer: {
    position: 'relative',
    height: '300px'
  },
  stats: {
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center'
  },
  device: {
    textAlign: 'center',
    padding: theme.spacing(1)
  },
  deviceIcon: {
    color: theme.palette.icon
  }
}));

const PercentuaisPorTipo = props => {
  const { className, ...rest } = props;

  const classes = useStyles();
  const theme = useTheme();

  let percExtra = rest.percExtra;
  let percFat = rest.percFat;  
  const data = {
    datasets: [
      {
        data: [percExtra, percFat],
        backgroundColor: [
          theme.palette.secondary.main,
          theme.palette.warning.main
        ],
        borderWidth: 1,
        borderColor: theme.palette.white,
        hoverBorderColor: theme.palette.white
      }
    ],
    labels: ['Extras', 'Faturado']
  };

  const options = {
    legend: {
      display: false
    },
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    animation: {
      animateRotate: false,
      animateScale: true,
    },
    cutoutPercentage: 0,
    layout: { padding: 0 },
    tooltips: {
      enabled: true,
      mode: 'index',
      intersect: false,
      borderWidth: 1,
      borderColor: theme.palette.divider,
      backgroundColor: theme.palette.white,
      titleFontColor: theme.palette.text.primary,
      bodyFontColor: theme.palette.text.secondary,
      footerFontColor: theme.palette.text.secondary
    }
  };

  
  const tipos = [
    {
      title: 'Extras',
      value: percExtra,
      //icon: <LaptopMacIcon />,
      color: theme.palette.secondary.main
    },
    {
      title: 'Faturado',
      value: percFat,
      //icon: <TabletMacIcon />,
      color: theme.palette.warning.main
    }
  ];

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader
        title="Percentuais por tipo"
      />
      <Divider />
      <CardContent>
        <div className={classes.chartContainer}>
          <Doughnut
            data={data}
            options={options}
          />
        </div>
        <div className={classes.stats}>
          {tipos.map(device => (
            <div
              className={classes.device}
              key={device.title}
            >
              <Typography variant="body1">{device.title}</Typography>
              <Typography
                style={{ color: device.color }}
                variant="h2"
              >
                {device.value}%
              </Typography>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

PercentuaisPorTipo.propTypes = {
  className: PropTypes.string
};

export default PercentuaisPorTipo;
